import Vue from 'vue';
import { LOAD_COUNTRIES } from '@/store/consts';
import { URL_LOAD_COUNTRIES } from "@/globals";

const countries = {
    state: {
        _locale: '',
        items: [],
        loading: false,
        loaded: false
    },
    mutations: {
        updateCountries(state, list) {
            state.items = list;
        },
        beginLoading(state, locale) {
            state._locale = locale;
            state.loading = true;
        },
        endLoading(state) {
            state.loading = false;
        }
    },
    actions: {
        [LOAD_COUNTRIES](context) {
            let curLocale = context.rootState.user.locale; 
            if (context.state.loading || context.state._locale == curLocale) return;

            console.log("Store: action:loadCountries...");
            context.commit('beginLoading', curLocale);
            Vue.get(URL_LOAD_COUNTRIES.format(curLocale), false, true)
                .then((result) => {
                    let list = [];
                    result.items.forEach((i) => list.push({ value: i.iso, text: i.name }));
                    
                    context.commit('updateCountries', list)
                    context.commit('endLoading');
                })
                .catch(() => {
                    this._countriesLoading = false;
                });
        }
    },
    getters: {
        countryNameByISO: state => iso => {
            
            let found = state.items.find(e => e.value.toLowerCase() == iso.toLowerCase());
            if (found) {
                return found.text
            } else {
                return iso.toUpperCase()
            }
            //console.log("getByISO: ", iso);
        },
    },
}

export default countries;